module.exports = __webpack_public_path__ + "img/ecosystem_01_rightball.334e047e.svg";